<style lang="scss" scoped>
.jobs-overview  {
    @apply min-h-screen;

    .component-fade-enter-active,
    .component-fade-leave-active {
        transition: opacity 0.3s ease;
    }
    .component-fade-enter,
    .component-fade-leave-to {
        opacity: 0;
    }
}

.hero {
    @apply lg:rounded-sm relative bg-green overflow-hidden -mx-20 md:-mx-24 lg:mx-0;
    height: 342px;
    @media (min-width: 1024px) {
        height: 254px;
    }
    &:after {
        content: "";
        background-color: rgba(30, 30, 30, 0.63);
        @apply inset-0 absolute w-100 h-100;
    }
}

#jobOrder {
    @apply bg-light font-dm text-dark text-small px-16 py-12 border border-light focus:border-light outline-none font-medium;
    letter-spacing: 0.1px;
}

::v-deep .filters {
    margin-top: -45px;
}
</style>

<template>
    <div class="jobs-overview">
        <transition name="component-fade" mode="out-in">
            <div class="relative">
                <div class="hero">
                    <img class="w-100 h-100 object-cover object-center" v-if="image" :src="image" :alt="title" />
                    <h1 class="top-116 lg:top-80 text-h2 w-100 absolute z-10 font-bold text-center text-white" v-html="`${jobs.length} ${title}`"></h1>
                </div>
                <job-search ref="jobSearch" class="relative z-10 flex items-stretch justify-center mb-40" v-model="search" @submit="searchClicked"></job-search>

                <div class="grid grid-cols-4 gap-24">
                    <div class="lg:flex hidden col-span-4">
                        <select v-model="search.sorting" @change="handleFilterChanged" name="order" class="ml-auto" id="jobOrder">
                            <option :value="null" selected disabled hidden>Sorteren</option>
                            <option value="added-desc">Nieuwste eerst</option>
                            <option value="added-asc">Oudste eerst</option>
                            <option v-if="search.long && search.lat" value="distance-asc">Dichtstbijzijnde</option>
                        </select>
                    </div>
                    <div class="lg:col-span-1 col-span-4">
                        <job-favorites ref="favorites" @click="showFavorites"></job-favorites>
                        <div class="lg:hidden border-green font-mon font-semiBold text-green text-p flex items-center justify-center py-16 mb-24 text-center border rounded-sm cursor-pointer" @click="showFilter = !showFilter">
                            <span v-html="svg('filter', 'w-16 h-16 path-stroke-green mr-8')"></span>
                            Filter
                        </div>
                        <div v-show="showFilter || isLg">
                            <!-- <job-filter v-model="filters.statute" @input="handleFilterChanged" title="Statuut" property="name" endpoint="/api/filter-statutes?used=true"></job-filter>
                            <job-filter v-model="filters.vacancy_regimes" @input="handleFilterChanged" title="Arbeidssysteem" property="slug" endpoint="/api/filter-regimes?used=true"></job-filter>
                            <job-filter v-model="filters.working_durations" @input="handleFilterChanged" title="Contract" property="slug" endpoint="/api/filter-durations?used=true"></job-filter> -->
                            <job-filter v-model="filters.contract_type" @input="handleFilterChanged" title="Type contract" property="id" endpoint="/api/contracts?used=true"></job-filter>
                        </div>
                    </div>
                    <div class="auto-rows-min md:grid-cols-6 lg:col-span-3 grid grid-cols-3 col-span-4 gap-24">
                        <div v-if="loading" class="p-80 flex items-center justify-center col-span-3 md:col-span-6"><el-loader :loading="loading" class="primary"></el-loader></div>
                        <div v-else-if="!loading && jobs.length === 0" class="p-80 flex flex-col items-center justify-center col-span-3 md:col-span-6 text-center">
                            <div class="text-dark font-mon text-h3 font-bold">Geen jobs gevonden.</div>
                            <div class="text-gray font-mon text-p">Er konden geen jobs gevonden worden, pas je zoekterm aan en probeer opnieuw.</div>
                        </div>
                        <template v-else><job-card class="lg:col-span-2 col-span-3" v-for="job in jobs" :key="job.id" :job="job"></job-card></template>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    components: { vSelect },

    props: {
        title: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            showFilter: false,

            jobs: [],

            search: {
                sorting: "added-desc",
                sector: [],
                rad: null,
                lat: null,
                long: null,
                location: null,
            },
            filters: {
                vacancy_regimes: [],
                working_durations: [],
                contract_type: [],
                statute: [],
            },
        };
    },
    created() {
        const uri = window.location.search.substring(1);
        const params = new URLSearchParams(uri);
        const sorting = params.get("sorting");
        if (sorting && ["added-desc", "added-asc", "distance-desc", "distance-asc"].includes(sorting)) {
            this.search.sorting = sorting;
        }
        const sector = params.get("sector");
        if (sector) {
            this.search.sector = sector.split(",");
        }
        const rad = params.get("rad");
        if (rad && rad !== "null") {
            this.search.rad = parseInt(rad);
        }
        const lat = params.get("lat");
        if (lat && lat !== "null") {
            this.search.lat = lat;
        }
        const long = params.get("long");
        if (long && long !== "null") {
            this.search.long = long;
        }
        const location = params.get("location");
        if (location && location !== "null") {
            this.search.location = location;
        }
    },
    mounted() {
        if (new URLSearchParams(window.location.search.substring(1)).get("favorites")) {
            this.$refs.favorites.showFavorites();
        } else {
            this.getJobs({ ...this.filters, ...this.search });
        }
    },

    methods: {
        getJobs(params) {
            console.log(params);
            this.loading = true;
            axios
                .get("/api/jobs", { params })
                .then((response) => (this.jobs = response.data))
                .finally(() => {
                    this.loading = false;
                    this.$refs.jobSearch.searching = false;
                });
        },
        handleFilterChanged: _.debounce(function () {            
            this.getJobs({ ...this.filters, ...this.search });
        }, 500),
        searchClicked: _.debounce(function () {            
            if (this.search.long && this.search.lat) {
                this.search.sorting = "distance-asc";
            }
            this.getJobs({ ...this.filters, ...this.search });
        }, 500),
        showFavorites(includes) {
            this.getJobs({ includes });
        },
    },

    computed: {
        isLg() {
            return window.innerWidth > 1024;
        },
    },
};
</script>
